<template lang="pug">
    section
        v-sheet(color="grey lighten-5" outlined)
            v-container(fluid)
                v-row.pa-0
                    v-col(lg="4" md="6" sm="12" xs="12").pa-0.pa-sm-2.pa-md-2.pa-lg-2
                        portfolio-composition
                    v-col(lg="8").pa-0.pa-sm-2.pa-md-2.pa-lg-2
                        client-balance-changes.mb-5
                        client-portfolio-changes
                v-row
                    v-col(offset=4).pa-0.pa-sm-2.pa-md-2.pa-lg-2


</template>

<script>
  import PortfolioComposition from '@/components/PortfolioComposition';
  import ClientBalanceChanges from '@/components/ClientBalanceChanges';
  import ClientPortfolioChanges from '@/components/ClientPortfolioChanges';

  export default {
    name: 'ClientPortfolio',
    components: {
      'portfolio-composition': PortfolioComposition,
      'client-balance-changes': ClientBalanceChanges,
      'client-portfolio-changes': ClientPortfolioChanges,
    },
    data() {
      return {};
    },
  };
</script>

<style scoped>

</style>
